import { Badge, Grid } from '@material-ui/core';
import { ShoppingCartOutlined } from '@material-ui/icons';
import classNames from 'classnames';
import CartPopup from 'components/cart-popup';
import { autobind } from 'core-decorators';
import { reverse } from 'core/urls';
import { checkPermission } from 'core/utils';
import cartQuery from 'graphql/queries/cart.gql';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import Menu from './menu';
import MenuProfile from './menu-profile';
import styles from './styles.css';
import User from './user';

@graphql(cartQuery, {
    skip: ({user}) => !user || !checkPermission(user, 'merchandising'),
})
@autobind
export default class Header extends Component {
    static propTypes = {
        user: PropTypes.object,
        onSessionOrganizationChange: PropTypes.func,
    };

    state = {
        menuVisible: false,
        profileMenu: false,
        cartAnchor: undefined,
    };

    handleShowMenu() {
        this.setState({menuVisible: true}, () => document.body.style.overflow = 'hidden');
    }

    handleHideMenu() {
        this.setState({menuVisible: false, profileMenu: false}, () => document.body.style.overflow = 'auto');
    }

    handleProfileMenu() {
        this.setState(this.state.profileMenu ? {profileMenu: false} : {profileMenu: true});
    }

    handleSetCartAnchor(anchorEl) {
        this.setState({cartAnchor: anchorEl});
    }

    renderCart() {
        const {cart} = this.props.data;
        if (!cart) return null;

        const cartCount = cart.items.map(item => item.quantity).reduce((a, b) => a + b, 0);
        return (
            <Fragment>
                <Badge badgeContent={cartCount} className={styles.badge} onClick={e => this.handleSetCartAnchor(e.currentTarget)}>
                    <ShoppingCartOutlined fontSize='large' />
                </Badge>
                {this.renderCartPopup()}
            </Fragment>
        );
    }

    renderCartPopup() {
        const {cart} = this.props.data;

        if (cart) { return <CartPopup anchorEl={this.state.cartAnchor} setAnchorEl={this.handleSetCartAnchor} cart={cart} />; }
    }

    render() {
        return (
            <div className={styles.root}>
                <Grid container justify='space-between' className={styles.container}>
                    {this.props.user && (
                        <div className={styles.userContainer}>
                            <Grid item >
                                <button onClick={this.handleProfileMenu} className={styles.username}>
                                    {this.state.profileMenu
                                        ? <i className={styles.closeIcon} />
                                        : <i className={styles.userIcon} />
                                    }
                                </button>
                            </Grid>
                            <Grid item className={styles.user}>
                                <User
                                    user={this.props.user}
                                    onSessionOrganizationChange={this.props.onSessionOrganizationChange}
                                    background
                                />
                            </Grid>
                        </div>
                    )}
                    <Grid item className={styles.logoContainer}>
                        <Link to={reverse('home')} className={styles.logo} />
                    </Grid>
                    {this.props.user && (
                        <Grid item style={{flexGrow:1}}>
                            <div className={styles.action}>
                                {checkPermission(this.props.user, 'merchandising') && (
                                    this.renderCart()

                                )}
                                <button
                                    onClick={this.state.menuVisible ? this.handleHideMenu : this.handleShowMenu}
                                    className={classNames(
                                        styles.menuIcon,
                                        {[styles.menuIconOnClick]: this.state.menuVisible},
                                    )}>
                                    <i className='material-icons'>menu</i>
                                </button>
                            </div>
                            <div
                                onClick={this.handleHideMenu}
                                className={classNames(styles.overlay, {[styles.visible]: this.state.menuVisible || this.state.profileMenu})}
                            />
                            <Menu
                                user={this.props.user}
                                visible={this.state.menuVisible}
                                onClose={this.handleHideMenu}
                                onSessionOrganizationChange={this.props.onSessionOrganizationChange}
                            />
                            <MenuProfile
                                user={this.props.user}
                                visible={this.state.profileMenu}
                                onClose={this.handleHideMenu}
                            />
                        </Grid>
                    )}
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/header/index.js